import misRutas from 'vue-routes-generator'
import ClientesComponent from './App'
import TraspasoCartera from './components/traspaso-cartera/traspaso-cartera.component.vue'

export default {
	install: Vue => {
		misRutas.route('/main').child('clientes', {
			name: 'Gestión de clientes',
			component: ClientesComponent
		})

		misRutas.route('/main').child('clientes/traspaso-cartera', {
			name: 'Traspaso de cartera',
			component: TraspasoCartera
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-clientes/vue/index.js